import api from '@/api';

const resource = 'merenda/deposito-da-escola';

export default {
  criarDepositoDaEscola( data ) {
    return api.post( `${resource}`, data );
  },

  editarDepositoDaEscola( data ) {
    return api.put( `${resource}/${data.identificadordepositoescola}`, data);
  },

  deletarDepositoDaEscola( id ) {
    return api.delete(`${resource}/${id}`);
  },

  buscarDepositoDaEscola(identificadorescola, data = null) {
    return api.get( `${resource}/deposito/${identificadorescola}`, {
      params: data
    });
  },
  listarDepositoDaEscola(data) {
    return api.get( `${resource}`, {
      params: data
    });
  },
};
